import React, { Component } from "react";
import { store } from "../../../Store/store";
import "./Search.css";
import TextField from "@material-ui/core/TextField";

let langData = require("../../../Data/language.json");

export default class Search extends Component {
  language = store.getState().firebase.language;

  render() {
    return (
      <form
        style={{ position: "relative" }}
        onSubmit={(e) => e.preventDefault()}
        className="searchForm"
      >
        <TextField
          label={
            <p>
              <img
                className="searchIcon"
                src={require("../../../Images/Icons/searchIcon.svg")}
                alt="searchIcon"
              />
              {langData[this.language].list.functions.search}
            </p>
          }
          className="textField"
          placeholder={langData[this.language].list.functions.searchPlaceholder}
          onChange={this.props.onSearch}
          margin="dense"
          variant="outlined"
          fullWidth={true}
          value={this.props.filter}
        />
        <div
          id="searchClear"
          style={this.props.filter ? { display: "flex" } : { display: "none" }}
          onClick={() => this.props.emptyFilter()}
        >
          <img
            src={require("../../../Images/Icons/No.svg")}
            alt="searchClearIcon"
            id="searchClearIcon"
          />
        </div>
      </form>
    );
  }
}
